module.exports = __webpack_public_path__ + "img/self.8e707663.png";